module.exports = __webpack_public_path__ + "img/Desktop-3.c4d20582.jpg";